import { createSlice } from '@reduxjs/toolkit';
import { SelectStore } from './types';

const initialState: SelectStore = {
  ShowComp: 'NULL',
  flagSHID: false,
  FParentCodes: [],
  holding: [],
};

const selectObjectsSlice = createSlice({
  name: 'select',
  initialState,
  reducers: {
    addObjectParam: (state, { payload }) => {
      const { key, value } = payload as { key: string; value: string };

      // Добавляем параметр в массив
      if (key === 'FParentCodes') {
        state.FParentCodes.push(value);
      } else if (key === 'holding') {
        // state.holding.push(value);
        state.holding = [value];
      }
    },
    removeObjectParam: (state, { payload }) => {
      const { key, value } = payload as { key: string; value: string };
      // Удаляем параметр из массива
      if (key === 'FParentCodes') {
        state.FParentCodes = state.FParentCodes.filter((item) => item !== value);
      }
      if (key === 'holding') {
        state.holding = state.holding.filter((item) => item !== value);
      }
    },
    clearSelect: (state) => {
      state.FParentCodes = [];
      // state.holding = [];
    },
  },
});

export const { addObjectParam, removeObjectParam, clearSelect } = selectObjectsSlice.actions;
export default selectObjectsSlice.reducer;
